/**
 * @flow
 * @relayHash a66980e95e624dbdd77bdfa6c8f1d326
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type UserMenu_viewer$ref = any;
export type UserMenuRefetchQueryVariables = {||};
export type UserMenuRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: UserMenu_viewer$ref
  |}
|};
export type UserMenuRefetchQuery = {|
  variables: UserMenuRefetchQueryVariables,
  response: UserMenuRefetchQueryResponse,
|};
*/


/*
query UserMenuRefetchQuery {
  viewer {
    ...UserMenu_viewer
    id
  }
}

fragment UserMenu_viewer on Viewer {
  userId
  locale
  serverTime
  displayName
  companyName
  isLogin
  isBusiness
  isActiveBusiness
  buyer {
    approvalFlag
  }
  unreadMessageCount
}
*/

const node/*: ConcreteRequest*/ = {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UserMenuRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "UserMenu_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UserMenuRefetchQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "userId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "locale",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "serverTime",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "displayName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "companyName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isLogin",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isBusiness",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "isActiveBusiness",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "buyer",
            "storageKey": null,
            "args": null,
            "concreteType": "Buyer",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "approvalFlag",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "unreadMessageCount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "UserMenuRefetchQuery",
    "id": null,
    "text": "query UserMenuRefetchQuery {\n  viewer {\n    ...UserMenu_viewer\n    id\n  }\n}\n\nfragment UserMenu_viewer on Viewer {\n  userId\n  locale\n  serverTime\n  displayName\n  companyName\n  isLogin\n  isBusiness\n  isActiveBusiness\n  buyer {\n    approvalFlag\n  }\n  unreadMessageCount\n}\n",
    "metadata": {}
  }
};
// prettier-ignore
(node/*: any*/).hash = '47dd49c8c85c8c2ac5e7328f66c13e25';
module.exports = node;
